const UrlPath = {
  paths: {
    assets: '/',
    css: '/',
    js: '/'
  }
};

export {UrlPath};
